/*=============================================== TooltipPage ===============================================*/

import { Tooltip, Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const TooltipPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Text>
                    Text with <Tooltip tooltip="Tooltip">tooltip</Tooltip> text
                </Text>
            ),
            code: '<Text>Text with <Tooltip tooltip="Tooltip">tooltip</Tooltip> text</Text>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "tooltip",
            type: "string",
            required: true,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default TooltipPage
